<template>
  <div>
    <br>
    <div style="text-align:left;">
      <router-link to="/adminhome"><< Back</router-link>
    </div>
    <br>
    <div class='row'>
      <div class='col-md-2 col-xs-12'>
        <div class='form-inline'>
          <input type='text' id='filterContext' class='form-control mb-2' v-model='filterContext' v-on:keyup="filter" placeholder='Search By Tags' />
          &nbsp;
          <div class='loader' v-show='filtering'></div>          
        </div>
      </div>
    </div>
    <table class="table table-stripe table-hover">
      <thead>
        <th>ID #</th>
        <th>To</th>
        <th>Subject</th>
        <th>Content</th>
        <th>Channel</th>
        <th>Attempt</th>
        <th>Last Sent</th>
        <th>Search Tags</th>
        <th>Actions</th>
      </thead>
      <tbody>
        <tr v-for="n in notifications">
          <td>{{n.id}}</td>
          <td>{{n.to}}</td>
          <td>
            {{n.subject}}
          </td>
          <td>
            <div v-if="n.content.length<50">{{ n.content }}</div>
            <div v-if="n.content.length>=50">{{ n.content.substring(0,50)+".." }}</div>
          </td>
          <td>
            {{n.channel}}
          </td>
          <td>
            {{n.attempt}}
          </td>
          <td>{{n.lastSent | moment("DD MMM YY, HH:mma")}}</td>
          <td>{{n.context}}</td>
          <td>
            <button class="btn btn-primary" v-on:click="resend(n.id)">Resend</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import http from "../commons/http.js";
export default {
  data: function() {
    return {
      notifications: [],
      filterContext:'',
      filterSearchTimeout:setTimeout(function(){}, 1000),
      filtering:false
    };
  },
  methods: {
    getNotifications: async function() {
      var response = await http.get("/notification");
      if (response.status == 200) {
        this.notifications = response.data;
      }
    },
    resend: async function(id){
      try{
        var response = await http.post("/notification/resend/"+id);
        if(response.status == 200){
          alert("Resend successful!");
          this.getNotifications();
        }
      }catch(err){
        alert("Resend failed. Please try again.");
      }
      
    },
    filter: async function(){
      this.clearFilterTimeout();
      
      let $this = this;
      this.filterSearchTimeout = setTimeout(async function(){
        $this.filtering = true;
        try{
          let response = await http.get('/notification/by?context='+$this.filterContext);
          $this.notifications = response.data;
        }catch(err){
          alert("An unexpected error encountered. Please try again.");
        }
        $this.filtering = false;
      }, 1000);
    },
    clearFilterTimeout: async function(){
      clearTimeout(this.filterSearchTimeout);
    }
  },
  beforeMount: function() {
    this.getNotifications();
  }
};
</script>

<style>
</style>
